<style lang="less">
.w-e-toolbar{
  align-items:center;
  justify-content:center;
}
.text {
  margin-left:auto;
  margin-right:auto;
  min-width: 1024px;
  max-width: 1680px;
}
.w-e-text-container {
  min-width: 1024px;
  max-width: 1680px;
}
.back-tast{
  display: flex;
  font-size:20px;
  cursor: pointer;
  margin-bottom:10px;
  &:hover{
    color: @primary-color;
  }
}
.tast-content{
  display: flex;
  align-items: center;
  justify-content:space-between;
  width: 100%;
  max-width:1100px;
  margin: 10px auto;
  border-radius: @border-radius-base;
  background-color: @white;
  padding: 15px 20px;
}
.rich-editor{
//   overflow: hidden;
  min-width: 1024px;
  max-width: 1680px;
  height: 800px;
  margin: 0 auto;
  margin-top: 50px;
}
.input-btn{
  padding:2px 10px;
  cursor: pointer;
  color:#51a3f5;
  &:hover {
    background-color:#EEE;
  }
}
.select_type{
    height: 80px;
    background: #fff;
    width: 100%;
    display: flex;
    text-align: right;
    padding: 30px;
    margin-bottom: 50px;
    .saveText{
      height: 30px;
      line-height:30px;
      padding: 0 10px;
      background: #FFFFFF;
      color: @primary-color;
      border-radius: 2px;
      border: 1px solid @primary-color;
      margin-right: 20px;
      text-align:center;
      margin-left: auto;
    }
    .submitText{
      height: 30px;
      line-height:30px;
      padding: 0 10px;
      background: @primary-color;
      color: #fff;
      border-radius: 2px;
      border: 1px solid @primary-color;
      text-align:center;
    }
}
// .ant-modal-content{
//     width: 350px;
// }
.ant-modal-confirm-body .ant-modal-confirm-title{
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 30px;
}
.ant-modal-confirm .ant-modal-confirm-btns{
    text-align: center;
}
.ant-btn{
    width: 80px;
    height: 24px;
    line-height: 24px;
}
.title{
  margin-bottom: 10px;
}
</style>
<template>
  <div class="rich-editor">
    <div class="title">
      <a-input v-model="title" placeholder="请输入文章标题" />
    </div>
    <div id="text-container" class="text"></div>
    <div class="select_type">
      <div style="line-height: 30px;">文章类型：</div>
        <a-select default-value="高考点拨" style="width:300px;" @change="handleChange">
            <a-select-option v-for="(item,index) in selectTop" :key="index" :value="item.id">
                {{item.name}}
            </a-select-option>
        </a-select>
        <a-button class="saveText" @click="saveTextFun">保存草稿</a-button>
        <a-button class="submitText" @click="submitFun">提交审核</a-button>
    </div>
    <div>
      <a-modal
        v-model="warnSure"
        title="提交审核确认"
        @ok="sureOk"
      >
        <div>
          文章审核期间，将不可修改文章，不可撤销文章。审核通过后，可以删除已提交的文章。
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import E from 'wangeditor'
import { decryptDes } from 'utils/crypto.js'
import axios from 'axios'
import html2canvas from 'html2canvas'
// import HanIcon from 'components/Icon.vue'
const getElement = () => {
  return new Promise((resolve, reject) => {
    let t = 0
    let getEditorTimer = setInterval(() => {
      const textContainer = document.getElementById('text-container')
      t++
      if (textContainer) {
        t = 0
        clearInterval(getEditorTimer)
        getEditorTimer = null
        resolve(textContainer)
      } else if (t > 100) {
        t = 0
        clearInterval(getEditorTimer)
        getEditorTimer = null
        reject(new Error('初始化编辑器失败!'))
      }
    }, 200)
  })
}
export default {
  name: 'writeBook',
  data () {
    return {
      loading: false,
      userId: null,
      styleId: null,
      activity: null,
      activityId: null,
      bookId: null,
      classId: null,
      editor: null,
      isPad: true,
      richText: '',
      myResourceVisible: false,
      recHistoryList: null,
      curResourceType: '',
      selectedFile: {},
      myNotes: {},
      subNcurrent: ['all'],
      selectedNotes: [],
      pageSize: 10,
      types: {
        all: 1,
        comment: 2,
        userLine: 3
      },
      title: '',// 文章标题
      editorContent:'',
      warnSure: false,
      status: 1, //默认提交审核
      token: '',
      selectTop: [
        {name: '高考点拨', id: 2},{name: '教学反思', id: 3},{name: '教学设计', id: 4},
        {name: '课程标准', id: 5},{name: '师生风采', id: 6},{name: '文本解读', id: 7},{name: '写作指导', id: 8}
      ],
      articleType: 2
    }
  },
  watch: {
    // $route(){
    //   this.editorContent = this.$route.query.item.content || ''
    //   this.title = this.$route.query.item.tilte || ''
    // }
  },
  mounted () {
    this.token = localStorage.getItem('access_token')
    this.initEditor()
  },
  methods: {
    initEditor () {
      getElement().then((textContainer) => {
        const editor = new E(textContainer)
        editor.config.showFullScreen = false // 隐藏全屏菜单
        // 上传本地图片
        editor.config.uploadImgMaxSize = 5 * 1024 * 1024 // 5M
        editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
        editor.config.uploadImgMaxLength = 1 // 一次最多上传 1 个图片
        editor.config.customUploadImg = (resultFiles, insertImgFn) => {
          const formData = new FormData()
          formData.append('file', resultFiles[0])
          formData.append('customDir', 'hytc_ebook_server/file')
          formData.append('access_token', this.token || '')
          const config = {
            'Content-Type': 'multipart/form-data'
          }
          axios.post(
            this.$uploadUrl,
            formData,
            config
          ).then((res) => {
            insertImgFn(`${this.$resBasePath}/${res.data.url}`)
          })
        }
        // 自定义获取我的图片 返回图片数组
        editor.config.customGetHisImg = () => {
          // console.log('customGetHisImg')
        }
        editor.config.excludeMenus = [
            'video',
            'audio'
        ]
        editor.config.height = 600
        editor.config.zIndex = 0
        editor.config.placeholder = '请输入文章内容'
        let _this = this
        editor.config.onchange = function (newHtml) {
           // console.log('change 之后最新的 html', newHtml)
            _this.editorContent = newHtml
        }
        editor.create()
            if(this.$route.query.item){
              this.editorContent = this.$route.query.item.content
              this.title = this.$route.query.item.title
              editor.txt.html(_this.editorContent)
          }else{
            this.editorContent = ''
            this.title = ''
          }
        // this.editor = editor
        // if (this.activity?.isCommit) editor.disable()
        // this.setEditorHeight()
      })
    },
    setEditorHeight () {
      const ele = this.$doc.querySelector('.w-e-text-container')
      const aele = this.$doc.querySelector('.tast-content')
      const aeHight = aele?.offsetHeight || 0
      const h = this.isPad ? 70 : 250
      if (ele) ele.style.height = `${this.$win.innerHeight - aeHight - h}px`
    },

    handleChange(e){
      this.articleType = e
    },
    submitFun(){
        if(this.title==''||this.editorContent==''){
          this.$message.error('缺少必要信息')
          return
        }
      this.warnSure = true
    },
    sureOk(){
        const params = {
          title: this.title,
          authorName: this.$getUserInfo().name,
          content: this.editorContent,
          fileList: [],
          status: this.status,
          articleType: this.articleType
        }
        this.$fetch({
            url: this.$baseUrl + 'ebook/teacher/article/saveArticle',
            body: params
        }).done(res => {
          if(res && res.success && res.resultCode ===0){
            this.$message.success('提交成功')
            this.warnSure = false
            this.$router.push({name: 'snailBookList'})
          }
        })
    },
    saveTextFun(){
      this.status = ''
      this.sureOk()
    }
  }
}
</script>
